import React, { memo, useContext } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Text } from '@cashfree-intl/coherent';
import RaiseIssue from 'containers/ProductTour/component/Shopify/SecondDay/RaiseIssue';
import { createStructuredSelector } from 'reselect';
import {
  closeHcFormAction,
  generateHcFormAction,
  openHcFormAction,
} from 'containers/LandingPage/actions';
import makeSelectLandingPage from 'containers/LandingPage/selectors';
import { showToast } from 'containers/Toast/actions';
import { MerchantDetailsContext } from 'contexts/MerchantDetailsContext';
import { FooterContainer, FooterContent, FooterStyledText } from 'containers/CheckoutJourney/styled';
import { FooterProps } from 'containers/CheckoutJourney/types';

const Footer = ({ generateHcForm, landingData, showError, closeHcForm, openHcForm }: FooterProps) => {
  const { merchantDetails } = useContext(MerchantDetailsContext);

  const handleHcOpen = () => {
    generateHcForm({
      merchantId: merchantDetails?.id,
      email: merchantDetails?.merchantEmail,
    });
  };

  return (
    <>
      <FooterContainer>
        <FooterContent fullWidth>
          <Text>
            Need help? Feel free to reach out to our{' '}
            <FooterStyledText
              as="span"
              onClick={handleHcOpen}
            >
              support team
            </FooterStyledText>
            for any questions or concerns. We&apos;re here for you!
          </Text>
        </FooterContent>
      </FooterContainer>

      <RaiseIssue
        landingData={landingData}
        generateHcForm={generateHcForm}
        showError={showError}
        closeHcForm={closeHcForm}
        openHcForm={openHcForm}
      />
    </>
  );
};

const mapStateToProps = createStructuredSelector({
  landingData: makeSelectLandingPage(),
});

const mapDispatchToProps = (dispatch: any) => ({
  generateHcForm: (data: any) => dispatch(generateHcFormAction(data)),
  showError: (data: any) => dispatch(showToast(data)),
  closeHcForm: () => dispatch(closeHcFormAction()),
  openHcForm: () => dispatch(openHcFormAction()),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(Footer);
